<div class="headings">
  <h4 class="content-heading">
    {{ 'pages.user-cards.create.steps.confirmation.heading' | translate }}
  </h4>
</div>

<article *ngIf="instructionsStepsConfirmation" class="article-mb quill-content-wrapper ql-editor" 
  [innerHTML]="instructionsStepsConfirmation | safeHtml">
</article>

<div class="user-bcitiCard">
 
  <div class="user-infos">
    <div class="avatar-block">
      <img class="user-avatar" [src]="picture" alt="demo-avatar">
      
      <span class="user-name">
          {{firstName}} {{lastName}}
      </span>
    </div>
    <div class="infos-block">
      <p><span class="label">{{ 'pages.user-cards.create.steps.confirmation.sex' | translate }}:</span> {{ 'pages.user-cards.create.steps.confirmation.' + sex | translate }}</p>
      <p><span class="label">{{ 'pages.user-cards.create.steps.confirmation.birthdate' | translate }}:</span> {{ birthDate }}</p>
      <p><span class="label">{{ 'pages.user-cards.create.steps.confirmation.address' | translate }}: </span>
        <span *ngIf="address.unit">{{ address.unit }} </span> {{ address.number }} {{ address.streetName }}, {{ address.city }}, {{ address.province }}, {{ address.postCode}}
      </p>
      <p *ngIf="subType"><span class="label">{{ 'pages.user-cards.create.steps.information.subTypes.label' | translate }}:</span>
        {{ subType.label }}
      </p>
    </div>

  </div>
</div>